import React from 'react';
import { render } from 'datocms-structured-text-to-html-string';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Icon,
  Flex,
  border,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import classes from '@in-person/Components/Utility/STstyle.module.css';
import { ceil } from 'lodash';

const CompareTabs = ({
  lang,
  region,
  sectionContent,
  pageData,
  pageName,
  prgData,
  isOpen,
  onClose,
}) => {
  const compareTabArray = [
    ...sectionContent[2].cards,
    ...sectionContent[4].cards,
  ];
  const numRows = ceil(compareTabArray.length / 2);
  return (
    <Box bg="white" py={12}>
      <Container maxW="6xl">
        <VStack spacing={10}>
          <Heading
            size="xl"
            textAlign="center"
            color="#3B444B"
            fontSize={{ base: '30px', md: '64px' }}
            fontWeight="normal"
            fontFamily="FedraSansStd-medium"
            maxW="2xl"
            lineHeight="115%"
          >
            {sectionContent[0].titleText}
          </Heading>
          <Box
            width={{ base: '100%', md: '100%', lg: '100%' }}
            maxW={{ base: '100%', md: '1030px', lg: '1030px' }}
            mx="auto"
            p={4}
            overflow="hidden"
          >
            <Box
              width={'100%'}
              display={'flex'}
              justifyContent={'center'}
              gap={3}
            >
              {[sectionContent[1].text, sectionContent[3].text].map(data => (
                <Box
                  bg="#FFF1D7"
                  py={5}
                  textAlign="center"
                  width={'50%'}
                  fontWeight="narmal"
                  fontSize={{ base: '18px', md: '36.4px' }}
                  fontFamily="FedraSansStd-medium"
                  color="#12166F"
                  letterSpacing="0.5px"
                >
                  {data}
                </Box>
              ))}
            </Box>
            <Grid
              templateRows={`repeat(${numRows} , 1fr)`}
              autoFlow="column"
              columnGap={3}
            >
              {compareTabArray.map((data, i) => (
                <GridItem
                  bg="#FFF7E8"
                  key={data.id}
                  px={'60px'}
                  overflow={'hidden'}
                >
                  <Flex
                    justifyContent="flex-start"
                    align="center"
                    py={'30px'}
                    gap={4}
                    height={'100%'}
                    borderBottom={
                      i === compareTabArray.length - 1 || i === numRows - 1
                        ? null
                        : '1px solid #00000030'
                    }
                  >
                    <Box pt={1} minW="32px">
                      <LazyLoadImageComponent
                        src={data?.image?.image?.url}
                        alt={data?.image?.image?.alt}
                        title={data?.image?.image?.title}
                        maxW="36px"
                        maxH="36px"
                      />
                    </Box>
                    <Box>
                      <StructuredTextParser
                        str={render(data?.description)}
                        mt={'0px'}
                        className={classes.CompareTabsStructured}
                        textAlign="left"
                        lineHeight="130%"
                        fontFamily="FedraSansStd-book"
                        fontWeight="400"
                        fontSize={{ base: '14px', md: '22px' }}
                        color={'#414141'}
                      />
                    </Box>
                  </Flex>
                </GridItem>
              ))}
            </Grid>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default CompareTabs;